import { Injectable, signal } from '@angular/core';
import { Observable, of, finalize } from 'rxjs';

/**
 * Lightweight registry that lets FormIframeComponent publish its own
 * canDeactivate logic so the route guard can consume it without needing
 * a @ViewChild query chain.
 */
@Injectable({ providedIn: 'root' })
export class FormDeactivateService {
  private canDeactivateFn: (() => Observable<boolean>) | null = null;

  /** True while the deactivation guard modal is open — prevents app-loader from covering the form. */
  readonly isGuardActive = signal(false);

  register(fn: () => Observable<boolean>): void {
    this.canDeactivateFn = fn;
  }

  clear(): void {
    this.canDeactivateFn = null;
  }

  get hasHandler(): boolean {
    return this.canDeactivateFn !== null;
  }

  run(): Observable<boolean> {
    if (!this.canDeactivateFn) return of(true);
    this.isGuardActive.set(true);
    return this.canDeactivateFn().pipe(
      finalize(() => this.isGuardActive.set(false)),
    );
  }
}
